import React from "react";

import { AccordionSummaryProps } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { PiWarningOctagon } from "react-icons/pi";

import { AccordionTag } from "./styles";

interface AccordionHeaderProps extends AccordionSummaryProps {
  title: string;
  step: number;
  subtitle: string;
  isMandatory: boolean;
  hasError?: boolean;
}

export function AccordionHeader(props: AccordionHeaderProps) {
  const { title, step, subtitle, isMandatory, hasError = false, ...rest } = props;
  const { t: translate } = useTranslation();

  return (
    <>
      {hasError ? (
        <AccordionTag.Step.Error>
          <PiWarningOctagon color={colors.error600} fontSize={20} />
          <span>{translate("pleaseCompleteAllRequiredFields")}</span>
        </AccordionTag.Step.Error>
      ) : null}
      <AccordionTag.Summary expandIcon={<MdOutlineKeyboardArrowDown />} {...rest}>
        <AccordionTag.Content>
          <AccordionTag.Step.Wrapper>
            <AccordionTag.Step.Number>
              <span>{step}</span>
            </AccordionTag.Step.Number>
            <AccordionTag.Step.TitleWrapper>
              <AccordionTag.Step.Title>{title}</AccordionTag.Step.Title>
              <AccordionTag.Step.Subtitle>{subtitle}</AccordionTag.Step.Subtitle>
            </AccordionTag.Step.TitleWrapper>
          </AccordionTag.Step.Wrapper>
          {isMandatory ? (
            <AccordionTag.Mandatory.Wrapper>
              <AccordionTag.Mandatory.Badge>{translate("mandatory")}</AccordionTag.Mandatory.Badge>
            </AccordionTag.Mandatory.Wrapper>
          ) : null}
        </AccordionTag.Content>
      </AccordionTag.Summary>
    </>
  );
}
